import Menu from 'Models/Menu';

export default [
  Menu.recordCreate,
  Menu.directoryCreate,
  Menu.organizationInformation,
  Menu.organizationEdit,
  Menu.organizationDelete,
  Menu.organizationClone,
  Menu.organizationsHelp,
];
